import api from '@/api/companyCulture'

const state = {

}

const actions = {
  getCompanyCulture ({ commit }) {
    return api.getCompanyCulture()
  },
  updateCompanyCulture ({ commit }, params) {
    return api.updateCompanyCulture(params)
  }

}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
